// extracted by mini-css-extract-plugin
module.exports = {"addColorButton":"WordCloudSection_addColorButton__34ib3","deleteColorButton":"WordCloudSection_deleteColorButton__2gPxq"};